import React, { useEffect } from "react";
import Navbar from "../Navbar";
import "./ViewCertificate.css";
import { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import DownloadPage from "../DownloadPage";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Box, Button, ThemeProvider, createTheme } from "@mui/material";

function UpdateInvoice() {
  const navigate = useNavigate();
  const [billInput, setbillInput] = useState({
    addMore: [{ index: Math.random(), certificate_nos: "", amount: "", hsn_code: ""}],//item list
    party_code: "",
    amount:"",
    remarks:"",
    certificate_id:"",
    month_of_test:"",
    userId:"",
    cash_related:"",
    billing_party_code:"",
  });
  const [linesDetails, setlinesDetails] = useState({
    billing_lines: [{ index: Math.random(), certificate_nos: "", amount: "", hsn_code: "",certificate_id:"",invoice_no:"",billing_header_id:""}],//item list
    invoice_no:"",
  });

  const [headerDetails, setheaderDetails] = useState({
    id: "",//item list
    invoice_no:"",
    customer_gst:""
  });

//   const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const { id } = useParams();
  useEffect(() => {
    const headerId = id;
    axios.get(`/api/invoice_details/${headerId}`).then((res) => {
      if (res.data.status === 200) {
        setheaderDetails(res.data.bill.billing_header[0]);
        setlinesDetails({ ...linesDetails, billing_lines: res.data.bill.billing_lines});
        // setlinesDetails({ ...linesDetails, invoice_no:res.data.bill.billing_header[0]['invoice_no']});
        // setheaderDetails(res.data.bill.billing_header[0]);
          console.log(linesDetails);  
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/showinvoices");
      }
      setLoading(false);
    });
  }, [id, navigate]);

  console.log('headerDetails',headerDetails);

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  // const handleInput = (e) => {
  //   e.persist();
  //   // console.log('target value',linesDetails.billing_lines[0]);
  //   setproduct({ ...productInput, [e.target.name]: e.target.value });
  //   setbillInput({...billInput, [e.target.name]: e.target.value})
  //   setDetails({ ...details[e.target.id], [e.target.name]: e.target.value});
  //   console.log(details)
  // };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   setlinesDetails((prevDetails) => {
  //     const updatedBillingLines = prevDetails.billing_lines.map((line) =>
  //       line.index === prevDetails.billing_lines.index
  //         ? { ...line, [name]: value }
  //         : line
  //     );

  //     return {
  //       ...prevDetails,
  //       billing_lines: updatedBillingLines,
  //     };
  //   });
  // };

  // const handleChange = (e, index) => {
  //   console.log("Updating row at index:", index);

  //   const { name, value } = e.target;
  //   console.log("Updating property:", name, "with value:", value);

  //   setlinesDetails((prevDetails) => {
  //     const updatedBillingLines = prevDetails.billing_lines.map((line) =>
  //       line.index == index ? { ...line, [name]: value } : line
  //     );

  //     console.log("Updated billing_lines array:", updatedBillingLines);

  //     return {
  //       ...prevDetails,
  //       billing_lines: updatedBillingLines,
  //     };
  //   });
  // };

  const handleChange = (e, index) => {
    const { name, value } = e.target;

    setlinesDetails((prevDetails) => {
      const updatedBillingLines = prevDetails.billing_lines.map((line, i) =>
        i === index ? { ...line, [name]: value } : line
      );

      return {
        ...prevDetails,
        billing_lines: updatedBillingLines,
      };
    });
  };


  if (loading) {
    swal({
      title: "Loading",
      text: "Please Wait!!!",
      timer: 1000,
      buttons: false,
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === "timer") {
          //console.log('I was closed by the timer')
        }
      }
    );
  }
 
  const [categorylist, setCategorylist] = useState([]);
  useEffect(() => {
    axios.get(`api/view-customer`).then((res) => {
      // console.log('setCategorylist',res)
    // axios.get(`https://cert.geekay.biz/backend/api/view-customer`).then((res) => {
      if (res.status === 200) {
        setCategorylist(res.data.customer);
      }
    });
  }, []);

  // const [billingDetails, setbillingDetails] = useState([]);
  useEffect(() => {
    const product_id = id;
    axios.get(`api/view_bill/${product_id}`).then((res) => {
    // console.log('billingDetails',res.data.billData)
    // axios.get(`https://cert.geekay.biz/backend/api/view-customer`).then((res) => {
      if (res.status === 200) {
        setbillInput(res.data.billData);
      }
    });
  }, []);

  const values = categorylist.map((item) => {
    return <option value={categorylist.acode}>{item.pcode}</option>;
  });

  const submitBill = (e) => {
    e.preventDefault();
    console.log('linesDetails',linesDetails)
    let userId = localStorage.getItem("auth_id");
    let data = linesDetails;

    // console.log(id);
    // const data = {
    //     billing_lines: linesDetails,
    //     billing_header: headerDetails,
    // }
    console.log(data,"ALi");

    axios.post(`/api/invoice_update`,data).then(res =>{
      if(res.data.status === 200){
        console.log('status',res.data.message)
        swal("Success",res.data.Message,"success");
        // document.getElementById('BILL_FORM').reset();
        navigate('/certificates/showinvoices');
      }
      else if(res.data.status === 400){
        setbillInput({...billInput,error_list:res.data.errors});

      }
    });
  }




  const challanId = id;
  return (
    <div>
      <main>
        <Navbar />
        <div className="row" style={{ marginTop: 20, width: "97%" }}>
            {/* // <div className="col-sm-1"></div> */}
            <div className="col-sm-12" style={{ marginLeft: 40 }}>
              <div className="card">
                <div className="card-header">
                  <h4>
                    <b>Update Invoice</b>
                  </h4>
                  </div>
                  <form onSubmit={submitBill}  id="BILL_FORM">
                    <div className="card-body">
                   
                          <section>
                            <table class="table table-bordered">
                              <thead>
                                <tr>
                                  <th className="tabheading" scope="col" style={{ width: "8%" }}>
                                   Sr.
                                  </th>
                                  <th className="tabheading" scope="col" style={{ width: "10%" }}>
                                      HSN Code
                                  </th>
                                  <th className="tabheading" scope="col" style={{ width: "28%" }}>
                                    Chapter Description
                                  </th>
                                  <th className="tabheading" scope="col" style={{ width: "38%" }}>
                                    Certificate Nos
                                  </th>
                                  <th className="tabheading" scope="col" style={{ width: "10%" }}>
                                    AMT. (in Rs.)
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                 {linesDetails.billing_lines.map((item, index) => ( 
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.hsn_code}</td>
                                    <td>{item.chapterDescription}</td>
                                    <td>{item.certificate_nos}</td>
                                    <td>
                                    <input type="text"  onChange={(e) => handleChange(e, index)} defaultValue={item.amount} style={{padding: "1px"}} name="amount" id={index} data-id={index} className="form-control " />
                                      </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </section>
            
                      <div className="row">
                        <ThemeProvider theme={theme}>
                          <Box
                           marginTop={1}
                           display="flex"
                           padding={3}
                           borderRadius={5}
                           alignItems="center"
                           justifyContent={"center"}
                           >
                            <Button
                              style={{
                                maxWidth: "200px",
                                maxHeight: "100px",
                                minWidth: "50px",
                                minHeight: "30px",
                              }}
                              color="apple"
                              type="submit"
                              variant="contained"
                            >
                              Submit
                            </Button>
                          </Box>
                        </ThemeProvider>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
          </div>
      </main>
    </div>
  )
}

export default UpdateInvoice